export default __webpack_public_path__ + "inporgress-hover.svg";